<template>
  <ul class="toast-list">
    <li v-for="toast in headerStore.toasts" :key="toast.id">
      <ToastItem :toast="toast" @hide-toast="onRemoveToast" />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import ToastItem from '@/components/ToastItem.vue';
import { useHeaderStore } from '@/stores/headerStore.ts';

const headerStore = useHeaderStore();

function onRemoveToast(id: number) {
  headerStore.removeToast(id);
}
</script>

<style lang="scss" scoped>
.toast-list {
  list-style-type: none;
  padding-left: 0;
}
</style>
